import React from 'react'
import "./order.scss"
const Order = () => {
    return (
        <div className='op'>
            <img src="./od.jpg" alt="" className='center' />
            <h1>Order Placed !!</h1><br />
            <br />
            <p>Thanks for choosing us for <br />&nbsp;&nbsp;&nbsp;&nbsp;delivering your needs.</p>
            <p>You can check your order status <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;in my order section</p>
        </div>
    )
}

export default Order
